import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { of } from "rxjs";
import { DocusignActions } from '../../actions/docusign/docusign.actions';
import { Store } from "@ngrx/store";
import { concatLatestFrom } from "@ngrx/operators";
import { AgreementsService } from '@services/agreements.service';
import { ErrorDialogService } from '@services/error-dialog.service';
import { selectUserOrgId } from '@store/selectors/user/user.selectors';

@Injectable()
export class DocusignEffects {



  openInWindow$ =  createEffect(() => {
    return this.actions$.pipe(
      ofType(DocusignActions.getSigningUrlSuccess),
      tap((action) => {
        if (action.url != null) {
          const signingCeremonyWindow = window.open(action.url, "_blank");
          if (!signingCeremonyWindow || signingCeremonyWindow.closed ||
            typeof signingCeremonyWindow.closed === 'undefined') {
            this.errorDialogService.showError('Popup was blocked. Please enable popups to sign the document.', 'Popup Blocked').subscribe();
          } else {
            signingCeremonyWindow.focus();
          }
        }
      })
    )
  }, { dispatch: false });





  DocusignOpenEnvelopeFailed$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DocusignActions.getSigningUrlFailure),
      tap(() => {
        this.errorDialogService.showError('Failed to open the signing document. Please try again.', 'Error').subscribe();
      })
    )
  }, { dispatch: false });



  sendDocusignEnvelope$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        DocusignActions.sendDocusignEnvelopeButtonPressed,
        DocusignActions.sendDocusignEnvelope
            ),
      concatLatestFrom(() => [
        this.store.select(selectUserOrgId),
      ]),
      switchMap(([action, orgId]) => {
        return this.agreementsService.makeEnvelope(orgId as number).pipe(
          map((data) => {
            return DocusignActions.sendDocusignEnvelopeSuccess();
          }),
          catchError((error) => of(DocusignActions.sendDocusignEnvelopeFailure({ error })))
        )

      })

    )
  });


  DocusignAgreementCreationFailed$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DocusignActions.sendDocusignEnvelopeFailure),
      tap(() => {
        this.errorDialogService.showError('Your document failed to create. Please contact an administrator.', 'Error').subscribe();
      })
    )
  }, { dispatch: false });




  constructor(
    private actions$: Actions,
    private agreementsService: AgreementsService,
    private store: Store,
    private errorDialogService: ErrorDialogService,
  ) {}
}
